
import CompaniesService from "@/services/companies.service";

const SET_LOADING = "setloading";
const SET_ALL_COMPANIES = "setAllCompanies";

export const GET_ALL_COMPANIES = "getAllCompanies";

export default {
    state: {
    companies: [],
    loading:false,
    total:null,
    },    
    mutations: {
    [SET_LOADING](state, loading){
        state.loading=loading;
    },
    [SET_ALL_COMPANIES](state, payload) {
        state.companies = payload;
    },
    },
    actions: {
    [GET_ALL_COMPANIES]({ commit, state }, params) {
        return new Promise((resolve, reject) => {
        commit(SET_LOADING, true);
        // Add list_view parameter for optimized listing endpoint

        const queryParams = { ...params, list_view: 'True'};
        CompaniesService.query(queryParams)
            .then(( data ) => {
                state.companies = data.data;
                commit(SET_LOADING, false);
                resolve(data);
            })
            .catch(({ error }) => {
                commit(SET_LOADING, false);
                reject(error);
            })
        });
    },
    },
    getters: {  
    companies(state) {
        return state.companies;
    }
    },
    
};
        
